import React, { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const faqs = [
  {
    question: "How do I find a financial advisor or financial agent near me in Mumbai?",
    answer:
      "Search for local advisors with proven results. At Shatrunjay, our financial advisors, investment advisors, and LIC agents offer trusted investment advice and smart financial planning.",
  },
  {
    question: "What is expert investment advice?",
    answer:
      "Expert investment advice is professional guidance on where and how to invest. Our investment managers and asset managers in Mumbai & Dombivli create safe strategies tailored to your goals and risk appetite.",
  },
  {
    question: "Can financial managers and wealth managers help me save tax?",
    answer:
      "Yes. We design tax-saving strategies under Section 80C and beyond. Clients rely on our wealth management solutions to reduce tax burdens and grow wealth effectively.",
  },
  {
    question: "Why should I plan for retirement early?",
    answer:
      "Planning early provides long-term financial freedom. Our wealth managers and financial advisors in Mumbai & Dombivli combine SIPs, life insurance, and investments to secure your retirement.",
  },
  {
    question: "How do I plan for my child’s education?",
    answer:
      "Our personal finance advisors and investment managers build education funds using SIPs, mutual funds, and insurance. This ensures your child’s dreams are financially supported.",
  },
  {
    question: "What is the role of an investment manager or wealth manager?",
    answer:
      "An investment manager or wealth manager organises your portfolio, balances your risk appetite, and creates strategies for long-term financial success.",
  },
  {
    question: "Do I really need a financial advisor, or can I manage my investments myself?",
    answer:
      "While you can invest on your own, a financial advisor provides expert guidance, helps you avoid costly mistakes, and ensures your money grows effectively.",
  },
  {
    question: "What is the difference between a financial agent and a financial manager?",
    answer:
      "A financial agent often helps with specific products like LIC or health insurance. A financial manager or wealth manager builds comprehensive strategies across taxes, insurance, retirement, and investments.",
  },
];

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="py-5 bg-light w-100">
      <div className="container-fluid px-3 px-md-5">
        <h2
          className="fw-bold mb-5 text-center"
          style={{ color: "#3A0063" }}
        >
          Frequently Asked Questions
        </h2>

        <div className="w-100 mx-auto">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="mb-3 border rounded-3 shadow-sm bg-white"
              style={{
                borderColor: activeIndex === index ? "#3A0063" : "#e5e5e5",
                transition: "all 0.3s ease",
              }}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-100 text-start p-4 d-flex justify-content-between align-items-center"
                style={{
                  backgroundColor: activeIndex === index ? "#f8f5ff" : "white",
                  border: "none",
                  borderRadius: "8px",
                  color: "#3A0063",
                  fontWeight: "600",
                  fontSize: "1.05rem",
                }}
              >
                <h3>{faq.question}</h3>
                {activeIndex === index ? (
                  <ChevronUp color="#3A0063" />
                ) : (
                  <ChevronDown color="#3A0063" />
                )}
              </button>

              {activeIndex === index && (
                <div
                  className="px-4 pb-4 text-muted"
                  style={{
                    borderTop: "1px solid #eee",
                    backgroundColor: "#faf9ff",
                    transition: "all 0.3s ease",
                      lineHeight: "1.7",
                    paddingTop:"20px"
                  }}
                >
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
